
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { reportError } from '@/utils/errorReporter';

export const fetchHowItWorksSteps = async () => {
    const { data, error } = await supabase
        .from('how_it_works_steps')
        .select('*')
        .order('display_order', { ascending: true });

    if (error) {
        console.error('Error fetching how it works steps:', error);
        reportError('Homepage/HowItWorks', error);
        return [];
    }
    return data;
};

export const useHowItWorks = () => {
    return useQuery({
        queryKey: ['how-it-works-steps'],
        queryFn: fetchHowItWorksSteps,
    });
};
